import { useApi, configApiRef } from '@backstage/core-plugin-api';

/**
 * Hook to get analytics access configuration from app-config
 * Reads the app.analytics.access configuration
 * Configuration value is an array of group entity references
 */
export const useAnalyticsAccessConfig = (): string[] => {
  const configApi = useApi(configApiRef);

  try {
    const configValue = configApi.getOptionalStringArray('app.analytics.access');
    
    if (!configValue || configValue.length === 0) {
      return [];
    }
    
    return configValue;
  } catch (error) {
    console.warn('[Analytics] Failed to read config for app.analytics.access:', error);
    return [];
  }
};
